<template>
    <el-dialog
        :model-value="props.visible"
        title="减免所得税类型选项表"
        width="1000"
        top="6vh"
        destroy-on-close
        :close-on-click-modal="false"
        @open="onOpen"
        @closed="closedModal"
    >
        <div v-loading="pageLoading">
            <div class="my-tax-enter-sub-table-wrap">
                <table>
                    <tbody>
                    <tr class="title-row">
                        <td class="title01 center strong" width="60">序号</td>
                        <td class="title01 center strong" width="80">选择</td>
                        <td class="title01 center strong" width="10%">代码</td>
                        <td class="title01 center strong" width="20%">类别</td>
                        <td class="title01 center strong">项目</td>
                        <td class="title01 center strong" width="200">本年累计金额</td>
                    </tr>
                    <tr class="">
                        <td class="title01 center ng-binding" ng-bind="jmsdGrid.jmsdGridlb[0].t_xh">1</td>
                        <td class="title01 center edit" isbinded="true">
                            <el-checkbox
                                v-model="tableData['JMSE00100'].checked"
                                :disabled="tableData['JMSE00100'].value != 0 || true"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" width="120" ng-bind="jmsdGrid.jmsdGridlb[0].yhswsx">JMSE00100
                        </td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[0].t_jejslxMc">小微企业</td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[0].jmsdssxMc">
                            符合条件的小型微利企业减免企业所得税
                        </td>
                        <td class="read right align-center" isbinded="true">
                            {{ parseFloatNum(tableData['JMSE00100'].value) }}
                        </td>
                    </tr>
                    <tr class="">
                        <td class="title01 center ng-binding" ng-bind="jmsdGrid.jmsdGridlb[1].t_xh">2</td>
                        <td class="title01 center" isbinded="true">
                            <el-checkbox
                                v-model="tableData['JMSE00201'].checked"
                                :disabled="tableData['JMSE00201'].value != 0 || true"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" width="120" ng-bind="jmsdGrid.jmsdGridlb[1].yhswsx">JMSE00201
                        </td>
                        <td class="title01 ng-binding" rowspan="2" ng-bind="jmsdGrid.jmsdGridlb[1].t_jejslxMc">
                            高新技术企业
                        </td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[1].jmsdssxMc">
                            高新技术企业减按15%的税率征收企业所得税
                        </td>
                        <td class="read right align-center" isbinded="true">
                            {{ parseFloatNum(tableData['JMSE00201'].value) }}
                        </td>
                    </tr>
                    <tr class="">
                        <td class="title01 center ng-binding" ng-bind="jmsdGrid.jmsdGridlb[2].t_xh">3</td>
                        <td class="title01 center read" isbinded="true">
                            <el-checkbox
                                v-model="tableData['JMSE00202'].checked"
                                :disabled="tableData['JMSE00202'].value != 0 || true"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" width="120" ng-bind="jmsdGrid.jmsdGridlb[2].yhswsx">JMSE00202
                        </td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[2].jmsdssxMc">
                            经济特区和上海浦东新区新设立的高新技术企业在区内取得的所得定期减免企业所得税
                        </td>
                        <td class="right read align-center" ng-class="isJmsdYhjmje2Editable() ? 'edit' : 'read'" isbinded="true">
                            {{ parseFloatNum(tableData['JMSE00202'].value) }}
                        </td>
                    </tr>
                    <tr class="">
                        <td class="title01 center ng-binding" ng-bind="jmsdGrid.jmsdGridlb[4].t_xh">4</td>
                        <td class="title01 center" isbinded="true">
                            <el-checkbox
                                v-model="tableData['JMSE00311'].checked"
                                :disabled="tableData['JMSE00311'].value != 0 || true"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" width="120" ng-bind="jmsdGrid.jmsdGridlb[4].yhswsx">JMSE00311
                        </td>
                        <td class="title01 ng-binding" rowspan="3" ng-bind="jmsdGrid.jmsdGridlb[4].t_jejslxMc">
                            原有软件集成电路优惠继续执行至到期
                        </td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[4].jmsdssxMc">
                            线宽小于0.25微米的集成电路生产企业减免企业所得税
                        </td>
                        <td class="read right align-center" isbinded="true">
                            {{ parseFloatNum(tableData['JMSE00311'].value) }}
                        </td>
                    </tr>
                    <tr class="">
                        <td class="title01 center ng-binding" ng-bind="jmsdGrid.jmsdGridlb[5].t_xh">5</td>
                        <td class="title01 center" isbinded="true">
                            <el-checkbox
                                v-model="tableData['JMSE00312'].checked"
                                :disabled="tableData['JMSE00312'].value != 0 || true"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" width="120" ng-bind="jmsdGrid.jmsdGridlb[5].yhswsx">JMSE00312
                        </td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[5].jmsdssxMc">
                            投资额超过80亿元的集成电路生产企业减免企业所得税
                        </td>
                        <td class="read right align-center" isbinded="true">
                            {{ parseFloatNum(tableData['JMSE00312'].value) }}
                        </td>
                    </tr>
                    <tr class="">
                        <td class="title01 center ng-binding" ng-bind="jmsdGrid.jmsdGridlb[11].t_xh">7</td>
                        <td class="title01 center" isbinded="true">
                            <el-checkbox
                                v-model="tableData['JMSE00315'].checked"
                                :disabled="tableData['JMSE00315'].value != 0 || true"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" width="120" ng-bind="jmsdGrid.jmsdGridlb[11].yhswsx">JMSE00315
                        </td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[11].jmsdssxMc">
                            线宽小于65纳米（含）或投资额超过150亿元的集成电路生产企业减免企业所得税
                        </td>
                        <td class="read right align-center" isbinded="true">
                            {{ parseFloatNum(tableData['JMSE00315'].value) }}
                        </td>
                    </tr>
                    <tr class="">
                        <td class="title01 center ng-binding" ng-bind="jmsdGrid.jmsdGridlb[12].t_xh">8</td>
                        <td class="title01 center" isbinded="true">
                            <el-checkbox
                                v-model="tableData['JMSE00301'].checked"
                                :disabled="tableData['JMSE00301'].value != 0 || true"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" width="120" ng-bind="jmsdGrid.jmsdGridlb[12].yhswsx">JMSE00301
                        </td>
                        <td class="title01 ng-binding" rowspan="10" ng-bind="jmsdGrid.jmsdGridlb[12].t_jejslxMc">
                            软件集成电路企业新政策
                        </td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[12].jmsdssxMc">
                            国家鼓励的线宽小于28纳米（含）集成电路生产企业减免企业所得税
                        </td>
                        <td class="read right align-center" isbinded="true">
                            {{ parseFloatNum(tableData['JMSE00301'].value) }}
                        </td>
                    </tr>
                    <tr class="">
                        <td class="title01 center ng-binding" ng-bind="jmsdGrid.jmsdGridlb[13].t_xh">9</td>
                        <td class="title01 center" isbinded="true">
                            <el-checkbox
                                v-model="tableData['JMSE00302'].checked"
                                :disabled="tableData['JMSE00302'].value != 0 || true"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" width="120" ng-bind="jmsdGrid.jmsdGridlb[13].yhswsx">JMSE00302
                        </td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[13].jmsdssxMc">
                            国家鼓励的线宽小于65纳米（含）集成电路生产企业减免企业所得税
                        </td>
                        <td class="read right align-center" isbinded="true">
                            {{ parseFloatNum(tableData['JMSE00302'].value) }}
                        </td>
                    </tr>
                    <tr class="">
                        <td class="title01 center ng-binding" ng-bind="jmsdGrid.jmsdGridlb[14].t_xh">10</td>
                        <td class="title01 center" isbinded="true">
                            <el-checkbox
                                v-model="tableData['JMSE00303'].checked"
                                :disabled="tableData['JMSE00303'].value != 0 || true"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" width="120" ng-bind="jmsdGrid.jmsdGridlb[14].yhswsx">JMSE00303
                        </td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[14].jmsdssxMc">
                            国家鼓励的线宽小于130纳米（含）集成电路生产企业减免企业所得税
                        </td>
                        <td class="read right align-center" isbinded="true">
                            {{ parseFloatNum(tableData['JMSE00303'].value) }}
                        </td>
                    </tr>
                    <tr class="">
                        <td class="title01 center ng-binding" ng-bind="jmsdGrid.jmsdGridlb[15].t_xh">11</td>
                        <td class="title01 center" isbinded="true">
                            <el-checkbox
                                v-model="tableData['JMSE00304'].checked"
                                :disabled="tableData['JMSE00304'].value != 0 || true"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" width="120" ng-bind="jmsdGrid.jmsdGridlb[15].yhswsx">JMSE00304
                        </td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[15].jmsdssxMc">
                            国家鼓励的集成电路设计企业减免企业所得税
                        </td>
                        <td class="read right align-center" isbinded="true">
                            {{ parseFloatNum(tableData['JMSE00304'].value) }}
                        </td>
                    </tr>
                    <tr class="">
                        <td class="title01 center ng-binding" ng-bind="jmsdGrid.jmsdGridlb[16].t_xh">12</td>
                        <td class="title01 center" isbinded="true">
                            <el-checkbox
                                v-model="tableData['JMSE00305'].checked"
                                :disabled="tableData['JMSE00305'].value != 0 || true"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" width="120" ng-bind="jmsdGrid.jmsdGridlb[16].yhswsx">JMSE00305
                        </td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[16].jmsdssxMc">
                            国家鼓励的重点集成电路设计企业减免企业所得税
                        </td>
                        <td class="read right align-center" isbinded="true">
                            {{ parseFloatNum(tableData['JMSE00305'].value) }}
                        </td>
                    </tr>
                    <tr class="">
                        <td class="title01 center ng-binding" ng-bind="jmsdGrid.jmsdGridlb[17].t_xh">13</td>
                        <td class="title01 center" isbinded="true">
                            <el-checkbox
                                v-model="tableData['JMSE00306'].checked"
                                :disabled="tableData['JMSE00306'].value != 0 || true"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" width="120" ng-bind="jmsdGrid.jmsdGridlb[17].yhswsx">JMSE00306
                        </td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[17].jmsdssxMc">
                            国家鼓励的集成电路装备企业减免企业所得税
                        </td>
                        <td class="read right align-center" isbinded="true">
                            {{ parseFloatNum(tableData['JMSE00306'].value) }}
                        </td>
                    </tr>
                    <tr class="">
                        <td class="title01 center ng-binding" ng-bind="jmsdGrid.jmsdGridlb[18].t_xh">14</td>
                        <td class="title01 center" isbinded="true">
                            <el-checkbox
                                v-model="tableData['JMSE00307'].checked"
                                :disabled="tableData['JMSE00307'].value != 0 || true"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[18].yhswsx">JMSE00307</td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[18].jmsdssxMc">
                            国家鼓励的集成电路材料企业减免企业所得税
                        </td>
                        <td class="read right align-center" isbinded="true">
                            {{ parseFloatNum(tableData['JMSE00307'].value) }}
                        </td>
                    </tr>
                    <tr class="">
                        <td class="title01 center ng-binding" ng-bind="jmsdGrid.jmsdGridlb[19].t_xh">15</td>
                        <td class="title01 center" isbinded="true">
                            <el-checkbox
                                v-model="tableData['JMSE00308'].checked"
                                :disabled="tableData['JMSE00308'].value != 0 || true"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[19].yhswsx">JMSE00308</td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[19].jmsdssxMc">
                            国家鼓励的集成电路封装、测试企业减免企业所得税
                        </td>
                        <td class="read right align-center" isbinded="true">
                            {{ parseFloatNum(tableData['JMSE00308'].value) }}
                        </td>
                    </tr>
                    <tr class="">
                        <td class="title01 center ng-binding" ng-bind="jmsdGrid.jmsdGridlb[20].t_xh">16</td>
                        <td class="title01 center" isbinded="true">
                            <el-checkbox
                                v-model="tableData['JMSE00309'].checked"
                                :disabled="tableData['JMSE00309'].value != 0 || true"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[20].yhswsx">JMSE00309</td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[20].jmsdssxMc">
                            国家鼓励的软件企业减免企业所得税
                        </td>
                        <td class="read right align-center" isbinded="true">
                            {{ parseFloatNum(tableData['JMSE00309'].value) }}
                        </td>
                    </tr>
                    <tr class="">
                        <td class="title01 center ng-binding" ng-bind="jmsdGrid.jmsdGridlb[21].t_xh">17</td>
                        <td class="title01 center" isbinded="true">
                            <el-checkbox
                                v-model="tableData['JMSE00310'].checked"
                                :disabled="tableData['JMSE00310'].value != 0 || true"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[21].yhswsx">JMSE00310</td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[21].jmsdssxMc">
                            国家鼓励的重点软件企业减免企业所得税
                        </td>
                        <td class="read right align-center" isbinded="true">
                            {{ parseFloatNum(tableData['JMSE00310'].value) }}
                        </td>
                    </tr>
                    <tr class="">
                        <td class="title01 center ng-binding" ng-bind="jmsdGrid.jmsdGridlb[22].t_xh">18</td>
                        <td class="title01 center" isbinded="true">
                            <el-checkbox
                                v-model="tableData['JMSE00401'].checked"
                                :disabled="tableData['JMSE00401'].value != 0 || true"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[22].yhswsx">JMSE00401</td>
                        <td class="title01 ng-binding" rowspan="2" ng-bind="jmsdGrid.jmsdGridlb[22].t_jejslxMc">
                            技术先进型服务企业
                        </td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[22].jmsdssxMc">
                            技术先进型服务企业（服务外包类）减按15%的税率征收企业所得税
                        </td>
                        <td class="read right align-center" isbinded="true">
                            {{ parseFloatNum(tableData['JMSE00401'].value) }}
                        </td>
                    </tr>
                    <tr class="">
                        <td class="title01 center ng-binding" ng-bind="jmsdGrid.jmsdGridlb[23].t_xh">19</td>
                        <td class="title01 center" isbinded="true">
                            <el-checkbox
                                v-model="tableData['JMSE00402'].checked"
                                :disabled="tableData['JMSE00402'].value != 0 || true"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[23].yhswsx">JMSE00402</td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[23].jmsdssxMc">
                            技术先进型服务企业（服务贸易类）减按15%的税率征收企业所得税
                        </td>
                        <td class="read right align-center" isbinded="true">
                            {{ parseFloatNum(tableData['JMSE00402'].value) }}
                        </td>
                    </tr>
                    <tr class="">
                        <td class="title01 center ng-binding" ng-bind="jmsdGrid.jmsdGridlb[24].t_xh">20</td>
                        <td class="title01 center" isbinded="true">
                            <el-checkbox
                                v-model="tableData['JMSE00501'].checked"
                                :disabled="tableData['JMSE00501'].value != 0 || true"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[24].yhswsx">JMSE00501</td>
                        <td class="title01 ng-binding" rowspan="4" ng-bind="jmsdGrid.jmsdGridlb[24].t_jejslxMc">
                            文化、环保、残疾人等特殊类型企业优惠
                        </td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[24].jmsdssxMc">
                            动漫企业自主开发、生产动漫产品定期减免企业所得税
                        </td>
                        <td class="read right align-center" isbinded="true">
                            {{ parseFloatNum(tableData['JMSE00501'].value) }}
                        </td>
                    </tr>
                    <tr class="">
                        <td class="title01 center ng-binding" ng-bind="jmsdGrid.jmsdGridlb[25].t_xh">21</td>
                        <td class="title01 center" isbinded="true">
                            <el-checkbox
                                v-model="tableData['JMSE00502'].checked"
                                :disabled="tableData['JMSE00502'].value != 0 || true"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[25].yhswsx">JMSE00502</td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[25].jmsdssxMc">
                            经营性文化事业单位转制为企业的免征企业所得税
                        </td>
                        <td class="read right align-center" isbinded="true">
                            {{ parseFloatNum(tableData['JMSE00502'].value) }}
                        </td>
                    </tr>
                    <tr class="">
                        <td class="title01 center ng-binding" ng-bind="jmsdGrid.jmsdGridlb[26].t_xh">22</td>
                        <td class="title01 center" isbinded="true">
                            <el-checkbox
                                v-model="tableData['JMSE00503'].checked"
                                :disabled="tableData['JMSE00503'].value != 0 || true"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[26].yhswsx">JMSE00503</td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[26].jmsdssxMc">
                            符合条件的生产和装配伤残人员专门用品企业免征企业所得税
                        </td>
                        <td class="read right align-center" isbinded="true">
                            {{ parseFloatNum(tableData['JMSE00503'].value) }}
                        </td>
                    </tr>
                    <tr class="">
                        <td class="title01 center ng-binding" ng-bind="jmsdGrid.jmsdGridlb[27].t_xh">23</td>
                        <td class="title01 center" isbinded="true">
                            <el-checkbox
                                v-model="tableData['JMSE00504'].checked"
                                :disabled="tableData['JMSE00504'].value != 0 || true"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[27].yhswsx">JMSE00504</td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[27].jmsdssxMc">
                            从事污染防治的第三方企业减按15%的税率征收企业所得税
                        </td>
                        <td class="read right align-center" isbinded="true">
                            {{ parseFloatNum(tableData['JMSE00504'].value) }}
                        </td>
                    </tr>
                    <tr class="">
                        <td class="title01 center ng-binding" ng-bind="jmsdGrid.jmsdGridlb[28].t_xh">24</td>
                        <td class="title01 center read" isbinded="true">
                            <el-checkbox
                                v-model="tableData['JMSE00601'].checked"
                                :disabled="tableData['JMSE00601'].value != 0 || true"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[28].yhswsx">JMSE00601</td>
                        <td class="title01 ng-binding" rowspan="10" ng-bind="jmsdGrid.jmsdGridlb[28].t_jejslxMc">
                            区域性优惠政策
                        </td>
                        <td class="title01 read" isbinded="true">
                            <div style="display: flex;align-items: center;flex-wrap: wrap;">
                                设在西部地区的鼓励类产业企业减按15%的税率征收企业所得税(主营业务收入占比
                                <div class="div-in-td">
                                    <el-input-number
                                        class="left-number-input"
                                        style="width: 100px;"
                                        :model-value="0.00"
                                        :controls="false"
                                        readonly
                                        :precision="2"
                                        :step="0.01"
                                        :value-on-clear="0.0"/>
                                </div>
                                %）
                            </div>

                        </td>
                        <td class="right read align-center" ng-class="isJmsdYhjmje28Editable() ? 'edit' : 'read'" isbinded="true">
                            {{ parseFloatNum(tableData['JMSE00601'].value) }}
                        </td>
                    </tr>
                    <tr>
                        <td class="title01 center ng-binding" ng-bind="jmsdGrid.jmsdGridlb[29].t_xh">25</td>
                        <td class="title01 center read" isbinded="true">
                            <el-checkbox
                                v-model="tableData['JMSE00602'].checked"
                                :disabled="tableData['JMSE00602'].value != 0 || true"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[29].yhswsx">JMSE00602</td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[29].jmsdssxMc">
                            新疆困难地区新办企业定期减免企业所得税
                        </td>
                        <td class="right read align-center" isbinded="true">
                            {{ parseFloatNum(tableData['JMSE00602'].value) }}
                        </td>
                    </tr>
                    <tr>
                        <td class="title01 center ng-binding" ng-bind="jmsdGrid.jmsdGridlb[30].t_xh">26</td>
                        <td class="title01 center read" isbinded="true">
                            <el-checkbox
                                v-model="tableData['JMSE00603'].checked"
                                :disabled="tableData['JMSE00603'].value != 0 || true"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[30].yhswsx">JMSE00603</td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[30].jmsdssxMc">
                            新疆喀什、霍尔果斯特殊经济开发区新办企业定期免征企业所得税
                        </td>
                        <td class="right read align-center" isbinded="true">
                            {{ parseFloatNum(tableData['JMSE00603'].value) }}
                        </td>
                    </tr>
                    <tr>
                        <td class="title01 center ng-binding" ng-bind="jmsdGrid.jmsdGridlb[32].t_xh">27</td>
                        <td class="title01 center read" isbinded="true">
                            <el-checkbox
                                v-model="tableData['JMSE00605'].checked"
                                :disabled="tableData['JMSE00605'].value != 0 || true"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[32].yhswsx">JMSE00605</td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[32].jmsdssxMc">
                            上海自贸试验区临港新片区的重点产业企业减按15%的税率征收企业所得税
                        </td>
                        <td class="right read align-center" isbinded="true">
                            {{ parseFloatNum(tableData['JMSE00605'].value) }}
                        </td>
                    </tr>
                    <tr class="">
                        <td class="title01 center ng-binding" ng-bind="jmsdGrid.jmsdGridlb[33].t_xh">28</td>
                        <td class="title01 center read" isbinded="true">
                            <el-checkbox
                                v-model="tableData['JMSE00606'].checked"
                                :disabled="tableData['JMSE00606'].value != 0 || true"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[33].yhswsx">JMSE00606</td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[33].jmsdssxMc">
                            海南自由贸易港鼓励类企业减按15%税率征收企业所得税
                        </td>
                        <td class="right read align-center" ng-class="isJmsdYhjmje33Editable() ? 'edit' : 'read'" isbinded="true">
                            {{ parseFloatNum(tableData['JMSE00606'].value) }}
                        </td>
                    </tr>
                    <tr class="">
                        <td class="title01 center ng-binding" ng-bind="jmsdGrid.jmsdGridlb[39].t_xh">29</td>
                        <td class="title01 center read" isbinded="true">
                            <el-checkbox
                                v-model="tableData['JMSE00607'].checked"
                                :disabled="tableData['JMSE00607'].value != 0 || true"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[39].yhswsx">JMSE00607</td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[39].jmsdssxMc">
                            福建平潭综合实验区企业减按15%税率征收企业所得税
                        </td>
                        <td class="right read align-center" ng-class="isJmsdYhjmje39Editable() ? 'edit' : 'read'" isbinded="true">
                            {{ parseFloatNum(tableData['JMSE00607'].value) }}
                        </td>
                    </tr>
                    <tr class="">
                        <td class="title01 center ng-binding" ng-bind="jmsdGrid.jmsdGridlb[40].t_xh">30</td>
                        <td class="title01 center read" isbinded="true">
                            <el-checkbox
                                v-model="tableData['JMSE00608'].checked"
                                :disabled="tableData['JMSE00608'].value != 0 || true"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[40].yhswsx">JMSE00608</td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[40].jmsdssxMc">
                            深圳前海深港现代服务业合作区企业减按15%税率征收企业所得税
                        </td>
                        <td class="right read align-center" ng-class="isJmsdYhjmje40Editable() ? 'edit' : 'read'" isbinded="true">
                            {{ parseFloatNum(tableData['JMSE00608'].value) }}
                        </td>
                    </tr>
                    <tr class="">
                        <td class="title01 center ng-binding" ng-bind="jmsdGrid.jmsdGridlb[41].t_xh">31</td>
                        <td class="title01 center read" isbinded="true">
                            <el-checkbox
                                v-model="tableData['JMSE00609'].checked"
                                :disabled="tableData['JMSE00609'].value != 0 || true"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[41].yhswsx">JMSE00609</td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[41].jmsdssxMc">
                            横琴粤澳深度合作区企业减按15%税率征收企业所得税
                        </td>
                        <td class="right read align-center" ng-class="isJmsdYhjmje41Editable() ? 'edit' : 'read'" isbinded="true">
                            {{ parseFloatNum(tableData['JMSE00609'].value) }}
                        </td>
                    </tr>

                    <tr class="">
                        <td class="title01 center ng-binding" ng-bind="jmsdGrid.jmsdGridlb[42].t_xh">32</td>
                        <td class="title01 center read" isbinded="true">
                            <el-checkbox
                                v-model="tableData['JMSE00610'].checked"
                                :disabled="tableData['JMSE00610'].value != 0 || true"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[42].yhswsx">JMSE00610</td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[42].jmsdssxMc">
                            南沙先行启动区鼓励类产业企业减按15%税率征收企业所得税
                        </td>
                        <td class="right read align-center" ng-class="isJmsdYhjmje42Editable() ? 'edit' : 'read'" isbinded="true">
                            {{ parseFloatNum(tableData['JMSE00610'].value) }}
                        </td>
                    </tr>
                    <tr class="">
                        <td class="title01 center ng-binding" ng-bind="jmsdGrid.jmsdGridlb[43].t_xh">33</td>
                        <td class="title01 center read" isbinded="true">
                            <el-checkbox
                                v-model="tableData['JMSE00611'].checked"
                                :disabled="tableData['JMSE00611'].value != 0 || true"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[43].yhswsx">JMSE00611</td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[43].jmsdssxMc">
                            河套深港科技创新合作区深圳园区特定封闭区域鼓励类产业企业减按15%的税率征收企业所得税
                        </td>
                        <td class="right read align-center" ng-class="isJmsdYhjmje43Editable() ? 'edit' : 'read'" isbinded="true">
                            {{ parseFloatNum(tableData['JMSE00611'].value) }}
                        </td>
                    </tr>
                    <tr class="">
                        <td class="title01 center ng-binding" ng-bind="jmsdGrid.jmsdGridlb[34].t_xh">34</td>
                        <td class="title01 center" isbinded="true">
                            <el-checkbox
                                v-model="tableData['JMSE99999'].checked"
                                :disabled="tableData['JMSE99999'].value != 0 || true"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[34].yhswsx">JMSE99999</td>
                        <td class="title01 ng-binding" ng-bind="jmsdGrid.jmsdGridlb[34].t_jejslxMc">其他</td>
                        <td class="title01 edit" isbinded="true">
                            <div style="display: flex;align-items: center;">
                                <span>其他</span>
                                （减免税代码：
                                <div class="div-in-td">
                                    <el-input-number
                                        class="left-number-input"
                                        style="width: 120px;"
                                        v-model.trim="tableData['JMSE99999'].disCode"
                                        :controls="false"
                                        disabled
                                        :step="0.01"
                                        :value-on-clear="0.0"/>
                                </div>
                                ）
                            </div>
                        </td>
                        <td class="edit right" isbinded="true">
                            <el-input-number
                                v-model.trim="tableData['JMSE99999'].value" :controls="false"
                                :precision="2" :step="0.01"
                                style="width: 130px;"
                                :value-on-clear="0.0"
                                disabled
                                @change="tableData['JMSE99999'].checked = true"
                            />
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div class="my-footer">
                <el-button
                    type="primary"
                    @click="onConfirm">确定
                </el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script setup>
import {ElMessage, ElMessageBox} from "element-plus";
import {cloneDeep} from "lodash";
import Big from "big.js";

const props = defineProps({
    visible: {
        type: Boolean,
        required: true
    },
    currentData: {
        type: Object,
        default: () => {
        }
    }
})

const initialData = {
    'JMSE00100': {
        name: '符合条件的小型微利企业减免企业所得税',
        checked: false,
        value: 0.00,
    },
    'JMSE00201': {
        name: '高新技术企业减按15%的税率征收企业所得税',
        checked: false,
        value: 0.00,
    },
    'JMSE00202': {
        name: '经济特区和上海浦东新区新设立的高新技术企业在区内取得的所得定期减免企业所得税',
        checked: false,
        value: 0.00,
    },
    'JMSE00311': {
        name: '线宽小于0.25微米的集成电路生产企业减免企业所得税',
        checked: false,
        value: 0.00,
    },
    'JMSE00312': {
        name: '投资额超过80亿元的集成电路生产企业减免企业所得税',
        checked: false,
        value: 0.00,
    },
    'JMSE00315': {
        name: '线宽小于65纳米（含）或投资额超过150亿元的集成电路生产企业减免企业所得税',
        checked: false,
        value: 0.00,
    },
    'JMSE00301': {
        name: '国家鼓励的线宽小于28纳米（含）集成电路生产企业减免企业所得税',
        checked: false,
        value: 0.00,
    },
    'JMSE00302': {
        name: '国家鼓励的线宽小于65纳米（含）集成电路生产企业减免企业所得税',
        checked: false,
        value: 0.00,
    },
    'JMSE00303': {
        name: '国家鼓励的线宽小于130纳米（含）集成电路生产企业减免企业所得税',
        checked: false,
        value: 0.00,
    },
    'JMSE00304': {
        name: '国家鼓励的集成电路设计企业减免企业所得税',
        checked: false,
        value: 0.00,
    },
    'JMSE00305': {
        name: '国家鼓励的重点集成电路设计企业减免企业所得税',
        checked: false,
        value: 0.00,
    },
    'JMSE00306': {
        name: '国家鼓励的集成电路装备企业减免企业所得税',
        checked: false,
        value: 0.00,
    },
    'JMSE00307': {
        name: '国家鼓励的集成电路材料企业减免企业所得税',
        checked: false,
        value: 0.00,
    },
    'JMSE00308': {
        name: '国家鼓励的集成电路封装、测试企业减免企业所得税',
        checked: false,
        value: 0.00,
    },
    'JMSE00309': {
        name: '国家鼓励的软件企业减免企业所得税',
        checked: false,
        value: 0.00,
    },
    'JMSE00310': {
        name: '国家鼓励的重点软件企业减免企业所得税',
        checked: false,
        value: 0.00,
    },
    'JMSE00401': {
        name: '技术先进型服务企业（服务外包类）减按15%的税率征收企业所得税',
        checked: false,
        value: 0.00,
    },
    'JMSE00402': {
        name: '技术先进型服务企业（服务贸易类）减按15%的税率征收企业所得税',
        checked: false,
        value: 0.00,
    },
    'JMSE00501': {
        name: '动漫企业自主开发、生产动漫产品定期减免企业所得税',
        checked: false,
        value: 0.00,
    },
    'JMSE00502': {
        name: '经营性文化事业单位转制为企业的免征企业所得税',
        checked: false,
        value: 0.00,
    },
    'JMSE00503': {
        name: '符合条件的生产和装配伤残人员专门用品企业免征企业所得税',
        checked: false,
        value: 0.00,
    },
    'JMSE00504': {
        name: '从事污染防治的第三方企业减按15%的税率征收企业所得税',
        checked: false,
        value: 0.00,
    },
    'JMSE00601': {
        name: '设在西部地区的鼓励类产业企业减按15%的税率征收企业所得税',
        checked: false,
        value: 0.00,
    },
    'JMSE00602': {
        name: '新疆困难地区新办企业定期减免企业所得税',
        checked: false,
        value: 0.00,
    },
    'JMSE00603': {
        name: '新疆喀什、霍尔果斯特殊经济开发区新办企业定期免征企业所得税',
        checked: false,
        value: 0.00,
    },
    'JMSE00605': {
        name: '上海自贸试验区临港新片区的重点产业企业减按15%的税率征收企业所得税',
        checked: false,
        value: 0.00,
    },
    'JMSE00606': {
        name: '海南自由贸易港鼓励类企业减按15%税率征收企业所得税',
        checked: false,
        value: 0.00,
    },
    'JMSE00607': {
        name: '福建平潭综合实验区企业减按15%税率征收企业所得税',
        checked: false,
        value: 0.00,
    },
    'JMSE00608': {
        name: '深圳前海深港现代服务业合作区企业减按15%税率征收企业所得税',
        checked: false,
        value: 0.00,
    },
    'JMSE00609': {
        name: '横琴粤澳深度合作区企业减按15%税率征收企业所得税',
        checked: false,
        value: 0.00,
    },
    'JMSE00610': {
        name: '南沙先行启动区鼓励类产业企业减按15%税率征收企业所得税',
        checked: false,
        value: 0.00,
    },
    'JMSE00611': {
        name: '河套深港科技创新合作区深圳园区特定封闭区域鼓励类产业企业减按15%的税率征收企业所得税',
        checked: false,
        value: 0.00,
    },
    'JMSE99999': {
        name: '其他：减免所得税类型未列明优惠',
        checked: false,
        value: 0.00,
        disCode: null,
    },
}

const pageLoading = ref(false)
const tableData = ref(cloneDeep(initialData))

function onOpen() {
    if (props.currentData.sub281.value != 0) { // 只要“符合条件的小型微利企业减免企业所得税”外面有值，这里就勾选并回显
        tableData.value['JMSE00100'].value = props.currentData.sub281.value
        tableData.value['JMSE00100'].checked = true
    }
    /*(props.currentData.subData || []).forEach(it => {
        tableData.value[it.key].value = it.value
        tableData.value[it.key].checked = it.checked
        if (it.disCode != null) {
            tableData.value[it.key].disCode = it.disCode
        }
    })*/
}

function onConfirm() {
    const resData = []
    let total = new Big(0) // 合计

    /*Object.keys(tableData.value).forEach(key => {
        if (tableData.value[key].checked) {
            resData.push({
                key,
                ...tableData.value[key],
            })
            total = total.plus(tableData.value[key].value)
        }
    })*/
    emit('update:visible', false)
    emit('onConfirm', resData, total.toNumber())
}

const emit = defineEmits(['update:visible', 'onConfirm'])

function closedModal() {
    emit('update:visible', false)
    tableData.value = cloneDeep(initialData)
}

function parseFloatNum(s, num = 2) {
    try {
        return new Big(s).toFixed(num);
    } catch (e) {
    }
}
</script>

<style scoped lang="scss">
.my-footer {
    display: flex;
    flex-direction: row-reverse;
    margin-top: 30px;
}

.my-tax-enter-sub-table-wrap {
    max-height: calc(80vh - 100px);
    overflow-y: auto;
    padding-right: 10px;
    padding-bottom: 3px;

    &::-webkit-scrollbar {
        width: 5px;
    }

    &::-webkit-scrollbar-track {
        background-color: transparent;
    }

    &::-webkit-scrollbar-track-piece {
        background-color: transparent;
    }

    &::-webkit-scrollbar-thumb {
        background-color: rgba(211, 211, 211, 0.9);
        border-radius: 10px;
    }

    > table {
        border: 1px solid #dcdcdc;
        border-collapse: collapse;

        tr {
            td {
                background-color: #fafafa;
                border: 1px solid #dcdcdc;
                padding: 10px 16px;

                &:nth-child(1) {
                    text-align: center;
                    width: 70px;
                }

                &:nth-child(2) {
                    width: 70px;
                    text-align: center;
                }

                &:nth-child(3) {
                    width: 120px;
                    text-align: center;
                }

                &:last-child {
                    width: 160px;
                    max-width: 160px;
                }
            }

            &.title-row {
                text-align: center;

                td {
                    font-weight: 700;
                }
            }
        }
    }
}

.align-center {
    text-align: center;
}

:deep(.left-number-input) {
    &.el-input-number .el-input__inner {
        text-align: left;
    }
}
</style>
